import { useQuery } from '@tanstack/react-query';
import {
  fetchProfileBundle,
  fetchProfileEvents,
  fetchViewerRsvpsForEvents,
} from '../../api/profiles';
import { queryKeys } from '../../lib/query/queryKeys';
import { GC, STALE } from '../../lib/query/staleTimes';

export function useProfileBundle(profileUserId, viewerUserId, { enabled = true } = {}) {
  const mode = viewerUserId && profileUserId === viewerUserId ? 'own' : 'public';
  return useQuery({
    queryKey: queryKeys.profiles.detail(profileUserId, mode),
    queryFn: () => fetchProfileBundle({ profileUserId, viewerUserId }),
    enabled: Boolean(profileUserId) && enabled,
    staleTime: STALE.semiStatic,
    gcTime: GC.long,
  });
}

export function useProfileEvents(profileUserId, { enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.profiles.events(profileUserId),
    queryFn: () => fetchProfileEvents(profileUserId),
    enabled: Boolean(profileUserId) && enabled,
    staleTime: STALE.user,
    gcTime: GC.long,
  });
}

export function useViewerRsvpsForProfile(viewerUserId, eventIds, { enabled = true } = {}) {
  const key = eventIds?.slice().sort().join(',') ?? '';
  return useQuery({
    queryKey: queryKeys.profiles.viewerRsvps(viewerUserId, key),
    queryFn: () => fetchViewerRsvpsForEvents(viewerUserId, eventIds),
    enabled: Boolean(viewerUserId) && Boolean(eventIds?.length) && enabled,
    staleTime: STALE.user,
  });
}
